import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

import { BREAKPOINT_DOWN_MEDIUM } from "config/constants";

import Navigation from "components/Library/Navigation";
import NewNavigation from "navigation/NewNavigation";

export class ConditionalNavigation extends Component {
  constructor(props) {
    super(props);

    this.onSizeChange = this._onSizeChange.bind(this);

    //the default value of mediaQuery before the component mounts
    //and gets the accurate value from the window is set to "large"
    //so that the old navigation renders.

    this.state = {
      showNewHeader:
        this.props.location.search.indexOf("newheader=true") !== -1,
      size: "large",
    };
  }

  componentDidMount() {
    this.mediaQuery = window.matchMedia(BREAKPOINT_DOWN_MEDIUM);
    this.setState({ size: this.getSize(this.mediaQuery) });
    this.mediaQuery.addListener(this.onSizeChange);
  }

  componentWillUnmount() {
    this.mediaQuery.removeListener(this.onSizeChange);
  }

  _onSizeChange(e) {
    this.setState({ size: this.getSize(e) });
  }

  /**
   * @param {MediaQueryList} mediaQuery
   */
  //returns small if window's current max width is breakpoint_down_medium,
  // else returns large
  getSize(mediaQuery) {
    return mediaQuery.matches ? "small" : "large";
  }

  render() {
    const isSmall = this.state.size === "small" ? true : false;

    return (
      <div>
        {this.state.showNewHeader && isSmall ? (
          <NewNavigation />
        ) : (
          <Navigation />
        )}
      </div>
    );
  }
}

ConditionalNavigation.propTypes = {
  location: PropTypes.object.isRequired,
};

export default withRouter(ConditionalNavigation);
